import { FacebookLogo, InstagramLogo, YoutubeLogo, LinkedinLogo, ArrowUpRight } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "./Reveal";
import { SOCIALS } from "@/data/content";

const ICONS = { FacebookLogo, InstagramLogo, YoutubeLogo, LinkedinLogo };

export default function Connect() {
  return (
    <section data-testid="connect-section" className="relative py-20 md:py-28">
      <div className="max-w-[88rem] mx-auto px-6 md:px-10">
        <SectionHeading chapter="05" overline="Social" title="Let's Connect" align="center" />
        <div className="grid grid-cols-1 gap-4 max-w-md mx-auto sm:max-w-none sm:flex sm:flex-wrap sm:justify-center md:gap-5" data-testid="social-links">
          {SOCIALS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.name} delay={0.07 * i}>
                <a
                  href={s.url}
                  data-testid={`social-${s.name.toLowerCase()}`}
                  aria-label={`${s.name} profile (placeholder link)`}
                  className="group flex w-full items-center justify-center gap-3 rounded-full border border-white/10 glass px-8 py-4 text-sm font-semibold text-zinc-200 hover:border-gold hover:text-gold transition-colors duration-300 sm:w-auto sm:min-w-[190px]"
                >
                  <Icon size={20} weight="fill" className="shrink-0" />
                  <span className="whitespace-nowrap">{s.name}</span>
                  <ArrowUpRight size={15} weight="bold" className="shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
